import { parseISO, format } from 'date-fns';
import { ru } from 'date-fns/locale';

Date.prototype.toJSON = function () {
    return this.format("yyyy-MM-dd");
    /*const originalHours = this.getHours();
    const hoursDiff = this.getHours() - this.getTimezoneOffset() / 60;
    this.setHours(hoursDiff);
    const timezoneString = this.toISOString();
    // set original hours so .toJSON does not change original value
    this.setHours(originalHours);

    return timezoneString;*/
};
Date.prototype.format = function (formatTokens: string): string {
    return format(this, formatTokens, { locale: ru })
}
// in case if ISO strings came from server
String.prototype.format = function (formatTokens: string): string {
    return format(parseISO(this as string), formatTokens, { locale: ru });
}
String.prototype.parseDate = function (): Date {
    return parseISO(this as string);
}
String.prototype.hideCenter = function (n: number):string {
    if(!this) return "";
    return `${this.substr(0, n)}${'*'.repeat(this.length-(n*2))}${this.substr(this.length-n, n)}`
}

Date.prototype.parseDate = function (): Date {
    if (typeof this == "string") return parseISO(this as unknown as string);
    else return this;
}
Date.prototype.addMinutes = function (minutes: number): Date {
    return new Date(this.setMinutes(this.getMinutes() + minutes));
};

Date.prototype.addHours = function (hours: number): Date {
    return new Date(this.setHours(this.getHours() + hours));
};

Date.prototype.addDays = function (days: number): Date {
    return new Date(this.setDate(this.getDate() + days));
};

Date.prototype.addMonths = function (month: number): Date {
    return new Date(this.setMonth(this.getMonth() + month));
};

Date.prototype.addYears = function (years: number): Date {
    return new Date(this.setFullYear(this.getFullYear() + years));
};
Date.prototype.getStartDay = function (days: number = 0): Date {
    const newDate = this.addDays(days);
    return new Date(newDate.toISOString().split("T")[0] + "T00:00:00")
};

Date.prototype.isSameDay = function (date: Date): boolean {
    if (this.getFullYear() == date.getFullYear()
        && this.getMonth() == date.getMonth()
        && this.getDate() == date.getDate()) {
        return true;
    }
    else return false;
}
Date.prototype.toPicker = function (): string {
    return this.format("yyyy-MM-dd");
};
Array.prototype.remove = function (index: number): void {
    this.splice(index, 1);
}
//String
String.prototype.replaceAllSubs = function (search: string, replace: string): string {
    return this.split(search).join(replace);
}